import React from 'react';
import useTranslation from '../../../core/customHooks/useTranslation';
import { EMoneyTypes, PrizeTypes } from '../../../core/constants/enums';
import {APP_CONSTANTS, PRIZE_TYPES} from '../../../core/constants/constants';
import PartnerModule from "../../../core/moduls/PartnerModul";
import {PARTNERS_WO_PRIZE_POOL} from "../../../core/constants/partnerSettingsConstants";


const PrizeItem =({ places, winning, prizeType, additionalPrize, currencySign, moneyType }) => {

  const translate = useTranslation();
  const partnerId = PartnerModule.getConfigItem(APP_CONSTANTS.PARTNER_ID);

  return (
    <div className="prize-row item">
      <div className="prize-cell">{places}</div>
      <div className="prize-cell">{winning} {moneyType !== EMoneyTypes.freeSpin && currencySign} {additionalPrize && ` + ${additionalPrize} ${prizeType && translate(PrizeTypes[prizeType])}` }</div>
      {
        !PARTNERS_WO_PRIZE_POOL.includes(partnerId) && moneyType !== EMoneyTypes.real &&
          <div className="prize-cell" title={translate(PRIZE_TYPES[moneyType])}>{translate(PRIZE_TYPES[moneyType])}</div>
      }
    </div>
  );
};

export default PrizeItem;
